export const RAIL_OPERATION_TYPE = [0, 1, 2]

export function isRailway(operationType) {
  return RAIL_OPERATION_TYPE.includes(operationType)
}
